import React, {useRef, useState} from "react";
import "./style.scss";
import {ReactComponent as ChooseFileIcon} from "../../../assets/icons/add-file-svgrepo-com.svg";
import {ReactComponent as SelectorIcon} from "../../../assets/icons/selectorIcon.svg";
import {ReactComponent as SelectorIcon2} from "../../../assets/icons/selectorIcon2.svg";

import SuccessModal from "../../../reusableComponents/SuccessModal";
import Select from "react-select";
import Card from "../../../reusableComponents/Card";
import {useDispatch, useSelector} from "react-redux";
import {getSupportData} from "../../../store/reducers/supportSlice";
import ErrorModal from "../../../reusableComponents/ErrorModal";
import {createSupportCases} from "../../../utils/apis";
import {ToastContainer, toast} from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import LoaderOverlay from "../../../reusableComponents/Loader";
import {useNavigate} from "react-router-dom";
import {useEffect} from "react";
import Spinner from "../../../reusableComponents/Spinner";
import customStyles from "../../../customstyle/customstyle";
const options = [
  {value: "option1", label: "Resolved"},
  {value: "option2", label: "In Progress"},
  {value: "option3", label: "Dismissed"},
];
const options2 = [
  {value: "option2", label: "Select or search"},
  {value: "option3", label: "General question"},
];
const options3 = [
  {value: "option1", label: "low"},
  {value: "option2", label: "medium"},
  {value: "option3", label: "high"},
  {value: "option4", label: "critical"},
];

const CreateCase = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [isLoading, setIsLoading] = useState(false);
  const [isSpinner, setIsSpinner] = useState(false);
  const [isModalOpen, setModalOpen] = useState(null);
  const [isErrorModal, setErrorModal] = useState(false);
  const [isErrorModalApi, setErrorModalApi] = useState(false);
  const [isErrorModalApiData, setErrorModalApiData] = useState("");
  const [selectedOption, setSelectedOption] = useState("general");
  // const [selectedDropdown1, setSelectedDropdown1] = useState(options[1]);
  const [selectedDropdown2, setSelectedDropdown2] = useState(null);
  const [selectedDropdown3, setSelectedDropdown3] = useState(null);
  const navigate = useNavigate();
  const handleNavigation = () => {
    navigate("/support-center");
  };
  const updateData = localStorage.getItem("updateValue");
  const parsedValue = JSON.parse(updateData);

  const [selectedFileName, setSelectedFileName] = useState(null);
  const [createCaseData, setCreateCaseData] = useState({
    case_type: selectedOption,
    attachment: selectedFileName,
    description: "",
    subject: "",
  });
  

  const fileInputRef = useRef(null);

  const handleCardClick = (option) => {
    setSelectedOption(option);
    setCreateCaseData({...createCaseData, case_type: option});
  };

  // const handleStatusChange = (selected) => {
  //   setSelectedDropdown1(selected);
  //   setCreateCaseData({...createCaseData, status: selected.label});
  // };
  const handleSubjectChange = (e) => {
    const subject = e.target.value;
    setCreateCaseData({...createCaseData, subject});
  };

  const handleCategoryChange = (selected) => {
    setSelectedDropdown2(selected);
    setCreateCaseData({...createCaseData, category: selected.label});
  };

  const handleSeverityChange = (selected) => {
    setSelectedDropdown3(selected);
    setCreateCaseData({...createCaseData, severity: selected.label});
  };

  const handleDescriptionChange = (e) => {
    const description = e.target.value;
    setCreateCaseData({...createCaseData, description});
  };

  // const handleAttachmentChange = (e) => {
  //   const attachment = e.target.files[0];
  //   setCreateCaseData({...createCaseData, attachment});
  // };

  const dispatch = useDispatch();
  // const dattat = useSelector((state) => state.support.message);
  //
  // const firstError = Object.keys(dattat).reduce((acc, key) => {
  //   if (dattat[key] && dattat[key].length > 0) {
  //     acc[key] = dattat[key][0];
  //   }
  //   return (acc[key] = dattat[key][0]);
  // }, {});
  //
  const handleAttachmentChange = (e) => {
    const fileInput = fileInputRef.current;
    if (fileInput && fileInput.files.length > 0) {
      const fileName = fileInput.files[0];
      setSelectedFileName(fileName);
    } else {
      setSelectedFileName("");
    }
    const fileType = fileInput?.files[0]?.type;

    if (fileType !== "image/png" && fileType !== "image/jpeg") {
      // alert("Please select a PNG or JPG file.");

      toast("Please select a PNG or JPG file.", {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        type: "error",
        theme: "dark",
        className: "custom-toast-container",
      });
      setSelectedFileName("");

      const fileSize = fileInput?.files[0]?.size;
      const maxSize = 500 * 1024;
      if (fileSize > maxSize) {
        toast("File size should be less than 500KB.", {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          type: "error",
          theme: "dark",
          className: "custom-toast-container",
        });
        fileInput.value = ""; // Reset the input field
        setSelectedFileName(""); // Clear the selected file name
        return;
      }
    }
    const fileSize = fileInput.files[0]?.size;
    const maxSize = 500 * 1024;
    if (fileSize > maxSize) {
      toast("File size should be less than 500KB.", {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        type: "error",
        theme: "dark",
        className: "custom-toast-container",
      });
      fileInput.value = ""; // Reset the input field
      setSelectedFileName(""); // Clear the selected file name
      return;
    }
  };

  const idToken = useSelector((state) => state.auth.idToken);
  const formData = new FormData();

  for (const key in createCaseData) {
    // Check if the property is not a function and has a value
    if (createCaseData.hasOwnProperty(key) && createCaseData[key] !== undefined) {
      // If it's the 'attachment' property and it's a File object
      if (key === "attachment") {
        formData.append("attachment", selectedFileName);
      } else {
        // For other properties
        formData.append(key, createCaseData[key]);
      }
    }
  }

  const [isModal, setModal] = useState(null);
  const handleCreateCase = async () => {
    // setIsLoading(true);

    if (createCaseData.case_type !== "" && createCaseData.subject !== "" && createCaseData.description !== "") {
      // Inject selected account to the payload
      if (createCaseData.case_type === "account_generation") {
        formData.set("description", formData.get("description") + ` Plan type: ${selectedDropdown2?.value} Login_id: ${selectedDropdown3?.value}`);
      }
      try {
        if (selectedFileName === null) {
          formData.delete("attachment");
        }
        // const data = selectedFileName === null ? {...formData, attachment: null} : formData;
        setIsSpinner(true);
        const res = await createSupportCases(idToken, formData);
        if (res.status < 400) {
          setModalOpen(true);
          setIsSpinner(false);
          dispatch(getSupportData(idToken));
        } else {
          throw new Error();
        }
      } catch (error) {
        setErrorModalApiData(error?.response?.data?.detail || "Something went wrong");
        setErrorModalApi(true);
      }
    } else {
      setIsLoading(false);
      setErrorModal(true);
    }

    setIsLoading(false);
  };
  useEffect(() => {
    if (isLoading) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [isLoading]);
  const accountList = useSelector((state) => state.account.accountList);
  const [login_id, setLogin_id] = useState(accountList.data);
  const uniqueChallenges = [...new Set(accountList?.data?.map((account) => account.challenge))];
  const loginFilter = (selected) => {
    const filterData = accountList.data.filter((ele, ind) => ele.challenge === selected.value);
    setLogin_id(filterData);
  };

  const handlePlanChange = (selected) => {
    setSelectedDropdown3(null);
    setSelectedDropdown2(selected);
    loginFilter(selected);
    // setCreateCaseData({...createCaseData, category: selected.label});
  };
  const handleLoginIdChange = (selected) => {
    setSelectedDropdown3(selected);
    // setCreateCaseData({...createCaseData, severity: selected.label});
  };
  useEffect(() => {
    if (isLoading) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [isLoading]);
  return (
    <Card className="economiccalender-container">
      <ToastContainer />
      {isLoading && <LoaderOverlay />}
      <div className="economiccalender-subcontainer">
        <div className="economiccalender-innercontainer selected-row-header">
          <h2 className="table-head">Create a Case</h2>
        </div>
        {parsedValue?.id === ""}
        <div className="cases-container">
          <div className="casesGroupA">
            <div className="cases-cards-div">
              <div
                className={`cases-card ${selectedOption === "general" ? "selected" : ""}`}
                onClick={() => handleCardClick("general")}
              >
                <div className="card-head">
                  <span>
                    <svg
                      width="24"
                      height="23"
                      viewBox="0 0 24 23"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M18.9171 14.434L18.7998 13.6932L18.9171 14.434ZM14.934 18.4171L14.1932 18.2998L14.934 18.4171ZM5.3502 19.2099L5.79103 18.6031L5.3502 19.2099ZM4.29013 18.1498L4.89689 17.709L4.29013 18.1498ZM19.7099 18.1498L20.3166 18.5906L19.7099 18.1498ZM18.6498 19.2099L19.0906 19.8166L18.6498 19.2099ZM18.6498 3.79013L18.209 4.39689L18.6498 3.79013ZM19.7099 4.8502L19.1031 5.29103L19.7099 4.8502ZM5.3502 3.79013L5.79103 4.39689L5.3502 3.79013ZM4.29013 4.8502L4.89689 5.29103L4.29013 4.8502ZM20.5973 14.375L21.3468 14.4007L20.5973 14.375ZM14.875 20.0973L14.9007 20.8468L14.875 20.0973ZM8.16667 10.75C7.75245 10.75 7.41667 11.0858 7.41667 11.5C7.41667 11.9142 7.75245 12.25 8.16667 12.25V10.75ZM15.8333 12.25C16.2475 12.25 16.5833 11.9142 16.5833 11.5C16.5833 11.0858 16.2475 10.75 15.8333 10.75V12.25ZM10.0833 6.91667C9.66912 6.91667 9.33333 7.25245 9.33333 7.66667C9.33333 8.08088 9.66912 8.41667 10.0833 8.41667V6.91667ZM13.9167 8.41667C14.3309 8.41667 14.6667 8.08088 14.6667 7.66667C14.6667 7.25245 14.3309 6.91667 13.9167 6.91667V8.41667ZM18.7998 13.6932C16.4285 14.0688 14.5688 15.9285 14.1932 18.2998L15.6748 18.5344C15.9487 16.805 17.305 15.4487 19.0344 15.1748L18.7998 13.6932ZM12 19.375C10.1865 19.375 8.8867 19.374 7.88066 19.265C6.88865 19.1575 6.27166 18.9523 5.79103 18.6031L4.90936 19.8166C5.6883 20.3826 6.59946 20.6349 7.71909 20.7562C8.82468 20.876 10.22 20.875 12 20.875V19.375ZM2.625 11.5C2.625 13.28 2.62397 14.6753 2.74375 15.7809C2.86506 16.9005 3.11743 17.8117 3.68336 18.5906L4.89689 17.709C4.5477 17.2283 4.3425 16.6113 4.23503 15.6193C4.12603 14.6133 4.125 13.3135 4.125 11.5H2.625ZM5.79103 18.6031C5.44792 18.3538 5.14618 18.0521 4.89689 17.709L3.68336 18.5906C4.02517 19.0611 4.4389 19.4748 4.90936 19.8166L5.79103 18.6031ZM19.1031 17.709C18.8538 18.0521 18.5521 18.3538 18.209 18.6031L19.0906 19.8166C19.5611 19.4748 19.9748 19.0611 20.3166 18.5906L19.1031 17.709ZM12 3.625C13.8135 3.625 15.1133 3.62603 16.1193 3.73503C17.1113 3.8425 17.7283 4.0477 18.209 4.39689L19.0906 3.18336C18.3117 2.61743 17.4005 2.36506 16.2809 2.24375C15.1753 2.12397 13.78 2.125 12 2.125V3.625ZM21.375 11.5C21.375 9.71996 21.376 8.32468 21.2562 7.21909C21.1349 6.09946 20.8826 5.1883 20.3166 4.40936L19.1031 5.29103C19.4523 5.77166 19.6575 6.38865 19.765 7.38066C19.874 8.3867 19.875 9.68655 19.875 11.5H21.375ZM18.209 4.39689C18.5521 4.64618 18.8538 4.94792 19.1031 5.29103L20.3166 4.40936C19.9748 3.9389 19.5611 3.52517 19.0906 3.18336L18.209 4.39689ZM12 2.125C10.22 2.125 8.82468 2.12397 7.71909 2.24375C6.59946 2.36506 5.6883 2.61743 4.90936 3.18336L5.79103 4.39689C6.27166 4.0477 6.88865 3.8425 7.88066 3.73503C8.8867 3.62603 10.1865 3.625 12 3.625V2.125ZM4.125 11.5C4.125 9.68655 4.12603 8.3867 4.23503 7.38066C4.3425 6.38865 4.5477 5.77166 4.89689 5.29103L3.68336 4.40936C3.11743 5.1883 2.86506 6.09946 2.74375 7.21909C2.62397 8.32468 2.625 9.71996 2.625 11.5H4.125ZM4.90936 3.18336C4.4389 3.52517 4.02517 3.9389 3.68336 4.40936L4.89689 5.29103C5.14618 4.94792 5.44792 4.64618 5.79103 4.39689L4.90936 3.18336ZM19.875 11.5C19.875 12.6244 19.8749 13.5557 19.8477 14.3493L21.3468 14.4007C21.3751 13.5759 21.375 12.6161 21.375 11.5H19.875ZM19.8477 14.3493C19.7868 16.1266 19.5883 17.0411 19.1031 17.709L20.3166 18.5906C21.0911 17.5247 21.2853 16.1965 21.3468 14.4007L19.8477 14.3493ZM20.5973 13.625C19.7529 13.625 19.2411 13.6233 18.7998 13.6932L19.0344 15.1748C19.3302 15.1279 19.6979 15.125 20.5973 15.125L20.5973 13.625ZM12 20.875C13.1161 20.875 14.0759 20.8751 14.9007 20.8468L14.8493 19.3477C14.0557 19.3749 13.1244 19.375 12 19.375V20.875ZM14.9007 20.8468C16.6965 20.7853 18.0247 20.5911 19.0906 19.8166L18.209 18.6031C17.5411 19.0883 16.6266 19.2868 14.8493 19.3477L14.9007 20.8468ZM15.625 20.0973C15.625 19.1979 15.6279 18.8302 15.6748 18.5344L14.1932 18.2998C14.1233 18.7411 14.125 19.2529 14.125 20.0973L15.625 20.0973ZM8.16667 12.25H15.8333V10.75H8.16667V12.25ZM10.0833 8.41667H13.9167V6.91667H10.0833V8.41667Z"
                        fill="#36D66B"
                      />
                    </svg>
                    General Issue
                  </span>
                  {selectedOption === "general" ? <SelectorIcon /> : <SelectorIcon2 />}
                </div>
                <p>Assistance with account and billing - related inquiries</p>
              </div>
              <div
                className={`cases-card ${selectedOption === "trade_related" ? "selected" : ""}`}
                onClick={() => handleCardClick("trade_related")}
              >
                <div className="card-head">
                  <span className="trade_icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="21"
                      height="20"
                      viewBox="0 0 21 20"
                      fill="none"
                    >
                      <path
                        d="M20.2502 8.58366C20.2502 5.90007 20.2502 4.55828 19.7279 3.53329C19.2685 2.63168 18.5355 1.89865 17.6339 1.43925C16.6089 0.916992 15.2671 0.916992 12.5835 0.916992H8.75016C6.06658 0.916992 4.72479 0.916992 3.69979 1.43925C2.79818 1.89865 2.06515 2.63168 1.60576 3.53329C1.0835 4.55828 1.0835 5.90007 1.0835 8.58366V12.6358C1.0835 14.6321 2.70176 16.2503 4.698 16.2503H5.27468C6.02132 16.2503 6.53186 17.0044 6.25457 17.6976C5.86311 18.6763 6.99018 19.561 7.84787 18.9484L10.3498 17.1613C10.3753 17.1431 10.3881 17.1339 10.4006 17.1251C11.1999 16.5619 12.1523 16.2567 13.13 16.2504C13.1454 16.2503 13.1611 16.2503 13.1924 16.2503H13.7184C15.3371 16.2503 16.1465 16.2503 16.8067 16.0567C18.3727 15.5976 19.5974 14.3729 20.0566 12.8069C20.2502 12.1467 20.2502 11.3373 20.2502 9.71854V8.58366Z"
                        stroke="#36D66B"
                        stroke-width="1.5"
                      />
                      <path
                        d="M7.79191 8.58333C7.79191 9.11261 7.36285 9.54167 6.83358 9.54167C6.3043 9.54167 5.87524 9.11261 5.87524 8.58333C5.87524 8.05406 6.3043 7.625 6.83358 7.625C7.36285 7.625 7.79191 8.05406 7.79191 8.58333Z"
                        fill="#36D66B"
                      />
                      <path
                        d="M11.6252 8.58333C11.6252 9.11261 11.1962 9.54167 10.6669 9.54167C10.1376 9.54167 9.70858 9.11261 9.70858 8.58333C9.70858 8.05406 10.1376 7.625 10.6669 7.625C11.1962 7.625 11.6252 8.05406 11.6252 8.58333Z"
                        fill="#36D66B"
                      />
                      <path
                        d="M15.4586 8.58333C15.4586 9.11261 15.0295 9.54167 14.5002 9.54167C13.971 9.54167 13.5419 9.11261 13.5419 8.58333C13.5419 8.05406 13.971 7.625 14.5002 7.625C15.0295 7.625 15.4586 8.05406 15.4586 8.58333Z"
                        fill="#36D66B"
                      />
                    </svg>
                    Trade Related
                  </span>
                  {selectedOption === "trade_related" ? <SelectorIcon /> : <SelectorIcon2 />}
                </div>
                <p>Requested to increase the service limit of your resources</p>
              </div>
              <div
                className={`cases-card ${selectedOption === "billing" ? "selected" : ""}`}
                onClick={() => handleCardClick("billing")}
              >
                <div className="card-head">
                  <span>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="21"
                      height="21"
                      viewBox="0 0 21 21"
                      fill="none"
                    >
                      <path
                        d="M18.8537 14.2644L19.4917 14.6587L18.8537 14.2644ZM18.6292 14.656L17.9319 14.3799L18.6292 14.656ZM18.6457 15.4545L19.3717 15.2664L18.6457 15.4545ZM18.5647 15.0827L19.3125 15.0249L18.5647 15.0827ZM15.2878 18.8125L15.0996 19.5385L15.2878 18.8125ZM14.9156 18.7315L14.973 17.9837L14.9156 18.7315ZM14.0981 19.0212L14.494 19.6582L14.0981 19.0212ZM14.4877 18.7967L14.7652 19.4935L14.4877 18.7967ZM17.5301 19.1928L17.3805 18.4578L17.5301 19.1928ZM19.026 17.6968L18.2911 17.5473L19.026 17.6968ZM6.36403 11.5308C5.94982 11.5308 5.61403 11.8666 5.61403 12.2808C5.61403 12.695 5.94982 13.0308 6.36403 13.0308V11.5308ZM14.0307 13.0308C14.4449 13.0308 14.7807 12.695 14.7807 12.2808C14.7807 11.8666 14.4449 11.5308 14.0307 11.5308V13.0308ZM10.1974 7.69746C9.78315 7.69746 9.44736 8.03325 9.44736 8.44746C9.44736 8.86167 9.78315 9.19746 10.1974 9.19746V7.69746ZM14.0307 9.19746C14.4449 9.19746 14.7807 8.86167 14.7807 8.44746C14.7807 8.03325 14.4449 7.69746 14.0307 7.69746V9.19746ZM4.08747 16.7464C0.637836 13.2968 0.637836 7.70385 4.08747 4.25422L3.02681 3.19356C-1.00861 7.22897 -1.00861 13.7717 3.02681 17.8071L4.08747 16.7464ZM4.08747 4.25422C7.5371 0.804584 13.1301 0.804584 16.5797 4.25422L17.6403 3.19356C13.6049 -0.841863 7.06223 -0.841863 3.02681 3.19356L4.08747 4.25422ZM13.7022 18.3842C12.0361 19.4195 10.1813 19.5486 8.44832 19.1413C6.7043 18.7314 5.12684 17.7858 4.08747 16.7464L3.02681 17.8071C4.25714 19.0374 6.08079 20.1258 8.10514 20.6015C10.1405 21.0799 12.4213 20.9463 14.494 19.6582L13.7022 18.3842ZM16.5797 4.25422C17.5704 5.24492 18.5162 6.82022 18.9371 8.57992C19.3556 10.3292 19.2448 12.2049 18.2157 13.8701L19.4917 14.6587C20.7781 12.577 20.884 10.271 20.396 8.23094C19.9105 6.20136 18.8266 4.37985 17.6403 3.19356L16.5797 4.25422ZM18.2157 13.8701C18.1081 14.0443 17.9943 14.2223 17.9319 14.3799L19.3265 14.9321C19.3208 14.9465 19.3216 14.94 19.3529 14.8864C19.3829 14.8348 19.4251 14.7664 19.4917 14.6587L18.2157 13.8701ZM19.3717 15.2664C19.3458 15.1661 19.3306 15.1074 19.3206 15.0629C19.3111 15.0212 19.3118 15.0158 19.3125 15.0249L17.817 15.1404C17.8299 15.3077 17.8781 15.4819 17.9197 15.6427L19.3717 15.2664ZM17.9319 14.3799C17.8302 14.6366 17.7957 14.8651 17.817 15.1404L19.3125 15.0249C19.3109 15.0044 19.3108 14.9922 19.311 14.9857C19.3111 14.9797 19.3115 14.9775 19.3115 14.9773C19.3115 14.9771 19.3118 14.9749 19.3135 14.9691C19.3152 14.9629 19.3189 14.9512 19.3265 14.9321L17.9319 14.3799ZM15.476 18.0865C15.3151 18.0448 15.1407 17.9966 14.973 17.9837L14.8582 19.4793C14.8491 19.4786 14.8546 19.4779 14.8962 19.4873C14.9407 19.4974 14.9993 19.5125 15.0996 19.5385L15.476 18.0865ZM14.494 19.6582C14.601 19.5917 14.6688 19.5496 14.72 19.5196C14.7729 19.4887 14.7794 19.4878 14.7652 19.4935L14.2102 18.0999C14.0524 18.1628 13.8752 18.2767 13.7022 18.3842L14.494 19.6582ZM14.973 17.9837C14.6973 17.9625 14.4671 17.9976 14.2102 18.0999L14.7652 19.4935C14.784 19.486 14.7955 19.4823 14.8018 19.4805C14.8077 19.4788 14.8101 19.4785 14.8105 19.4784C14.8109 19.4783 14.8133 19.4779 14.8194 19.4778C14.8259 19.4776 14.838 19.4777 14.8582 19.4793L14.973 17.9837ZM15.0996 19.5385C15.692 19.692 16.1728 19.8171 16.5592 19.8899C16.942 19.9621 17.3172 20.0014 17.6796 19.9277L17.3805 18.4578C17.3087 18.4724 17.1655 18.4778 16.8371 18.4159C16.5122 18.3546 16.089 18.2454 15.476 18.0865L15.0996 19.5385ZM17.9197 15.6427C18.0786 16.2557 18.1879 16.6789 18.2492 17.0039C18.3111 17.3323 18.3057 17.4755 18.2911 17.5473L19.7609 17.8464C19.8347 17.484 19.7954 17.1087 19.7232 16.7259C19.6503 16.3396 19.5253 15.8587 19.3717 15.2664L17.9197 15.6427ZM17.6796 19.9277C18.7281 19.7143 19.5476 18.8949 19.7609 17.8464L18.2911 17.5473C18.1977 18.006 17.8392 18.3645 17.3805 18.4578L17.6796 19.9277ZM6.36403 13.0308H14.0307V11.5308H6.36403V13.0308ZM10.1974 9.19746L14.0307 9.19746V7.69746L10.1974 7.69746V9.19746Z"
                        fill="#36D66B"
                      />
                    </svg>
                    Billing Issues
                  </span>
                  {selectedOption === "billing" ? <SelectorIcon /> : <SelectorIcon2 />}
                </div>
                <p>Service - related technical issues and third-party applications</p>
              </div>
              <div
                className={`cases-card ${selectedOption === "account_generation" ? "selected" : ""}`}
                onClick={() => handleCardClick("account_generation")}
              >
                <div className="card-head">
                  <span>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="28"
                      height="28"
                      viewBox="0 0 28 28"
                      fill="none"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M15.1 19H17.025C20.822 19 23.9 15.8909 23.9 12.0556C23.9 8.22022 20.822 5.11111 17.025 5.11111H10.975C7.17802 5.11111 4.1 8.22022 4.1 12.0556C4.1 16.4525 6.96919 19.1409 10.1081 20.7923C11.6672 21.6125 13.2375 22.1426 14.425 22.4674C14.6682 22.5339 14.8943 22.5916 15.1 22.6412V19ZM16.2 24C16.2 24 15.7841 23.9387 15.1 23.7821C11.9299 23.0559 3 20.2806 3 12.0556C3 7.60661 6.57055 4 10.975 4H17.025C21.4295 4 25 7.60661 25 12.0556C25 16.5045 21.4295 20.1111 17.025 20.1111H16.2V24Z"
                        fill="#36D66B"
                      />
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M14.729 7.14796C13.9855 7.12385 13.207 7.26524 12.5585 7.58553C11.9096 7.906 11.3375 8.4364 11.143 9.2079C11.0658 9.51422 11.2471 9.82632 11.548 9.90495C11.8489 9.98358 12.1554 9.79901 12.2327 9.49263C12.3181 9.15384 12.5848 8.84552 13.0495 8.61599C13.5082 8.3895 14.1007 8.27354 14.6933 8.29272C15.289 8.31202 15.8287 8.46572 16.2012 8.7181C16.3607 8.82616 16.508 8.96182 16.6108 9.14336C16.7172 9.3312 16.7501 9.52247 16.7501 9.69633C16.7501 9.97688 16.6703 10.1788 16.5519 10.3374C16.4275 10.504 16.2409 10.6479 15.9988 10.7672C15.5055 11.0103 14.8881 11.1003 14.4626 11.1293C14.1672 11.1494 13.9377 11.3992 13.9377 11.7007V12.5597C13.9377 12.8759 14.1896 13.1323 14.5002 13.1323C14.7879 13.1323 15.0257 12.912 15.0587 12.6284C15.0869 12.386 15.2629 12.1884 15.4971 12.1362C15.8265 12.0629 16.1703 11.9551 16.4889 11.7981C17.2008 11.4473 17.8751 10.7973 17.8751 9.69633C17.8751 8.82948 17.4374 8.17996 16.8245 7.76461C16.2305 7.36214 15.4696 7.17195 14.729 7.14796ZM12.0675 6.55502C12.906 6.14092 13.8705 5.97422 14.7648 6.0032C15.65 6.03183 16.6321 6.25849 17.4477 6.81112C18.3153 7.39902 19 8.37954 19 9.69633C19 11.393 17.9183 12.3662 16.979 12.829C16.679 12.9769 16.3717 13.087 16.0781 13.1696C15.8363 13.8175 15.2214 14.2777 14.5002 14.2777C13.5682 14.2777 12.8128 13.5085 12.8128 12.5597V11.7007C12.8128 10.7964 13.5013 10.0469 14.3875 9.9865C14.7659 9.96073 15.211 9.88296 15.5087 9.73624C15.547 9.7174 15.5764 9.70045 15.5987 9.68625C15.5926 9.68173 15.5857 9.67686 15.5779 9.67159C15.4264 9.56891 15.1076 9.45203 14.6575 9.43748C14.216 9.42317 13.8095 9.51365 13.5405 9.64651C13.3903 9.72067 13.3334 9.77902 13.3161 9.80113C13.0747 10.7059 12.1632 11.2482 11.2683 11.0143C10.3656 10.7784 9.82167 9.84213 10.0534 8.92311C10.3568 7.71982 11.2334 6.967 12.0675 6.55502ZM14.5002 15.7093C14.1896 15.7093 13.9377 15.9657 13.9377 16.282C13.9377 16.5983 14.1896 16.8547 14.5002 16.8547C14.8109 16.8547 15.0627 16.5983 15.0627 16.282C15.0627 15.9657 14.8109 15.7093 14.5002 15.7093ZM12.8128 16.282C12.8128 15.3332 13.5682 14.564 14.5002 14.564C15.4321 14.564 16.1876 15.3332 16.1876 16.282C16.1876 17.2309 15.4321 18 14.5002 18C13.5682 18 12.8128 17.2309 12.8128 16.282Z"
                        fill="#36D66B"
                      />
                    </svg>
                    Account Support
                  </span>
                  {selectedOption === "account_generation" ? <SelectorIcon /> : <SelectorIcon2 />}
                </div>
                <p>Assistance with account and billing - related inquiries</p>
              </div>
              <div
                className={`cases-card ${selectedOption === "feedback" ? "selected" : ""}`}
                onClick={() => handleCardClick("feedback")}
              >
                <div className="card-head">
                  <span>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="29"
                      height="28"
                      viewBox="0 0 29 28"
                      fill="none"
                    >
                      <g clip-path="url(#clip0_1_6730)">
                        <path
                          d="M14.6666 8.71801C16.6612 8.71801 18.2839 7.09527 18.2839 5.1007C18.2839 3.10614 16.6612 1.4834 14.6666 1.4834C12.672 1.4834 11.0493 3.10614 11.0493 5.1007C11.0493 7.09521 12.672 8.71801 14.6666 8.71801ZM14.6666 3.22962C15.6982 3.22962 16.5376 4.06891 16.5376 5.10059C16.5376 6.13227 15.6983 6.97156 14.6666 6.97156C13.6349 6.97156 12.7957 6.13227 12.7957 5.10059C12.7957 4.06897 13.635 3.22962 14.6666 3.22962Z"
                          fill="#36D66B"
                        />
                        <path
                          d="M8.83316 17.4305H20.5002C20.9825 17.4305 21.3734 17.0395 21.3734 16.5573C21.3734 12.8592 18.3648 9.85059 14.6667 9.85059C10.9686 9.85059 7.95996 12.8592 7.95996 16.5573C7.95996 17.0395 8.35092 17.4305 8.83316 17.4305ZM19.55 15.6841H9.7833C10.7505 10.2596 18.5838 10.2651 19.55 15.6841Z"
                          fill="#36D66B"
                        />
                        <path
                          d="M18.1908 20.782L16.2969 20.5067L15.4499 18.7906C15.1302 18.1429 14.2036 18.1425 13.8838 18.7906L13.0368 20.5067L11.1429 20.782C10.4282 20.8858 10.1415 21.767 10.659 22.2714L12.0294 23.6073L11.7058 25.4935C11.5837 26.2053 12.3332 26.7504 12.9728 26.414L14.6668 25.5235L16.3608 26.414C16.9965 26.7483 17.7507 26.2102 17.6277 25.4935L17.3042 23.6073L18.6746 22.2714C19.1919 21.7672 18.9059 20.886 18.1908 20.782ZM15.6075 24.0449C14.5955 23.513 14.676 23.5457 13.7263 24.0449C13.9084 22.9836 13.966 23.0561 13.145 22.2558C14.2111 22.1009 14.1595 22.1782 14.6669 21.1501C15.1728 22.1752 15.1212 22.1007 16.1888 22.2558C15.3702 23.0537 15.4251 22.9817 15.6075 24.0449Z"
                          fill="#36D66B"
                        />
                        <path
                          d="M8.46246 20.782L6.56853 20.5067L5.72153 18.7906C5.40188 18.1429 4.47531 18.1425 4.1555 18.7906L3.30855 20.5067L1.41461 20.782C0.699902 20.8858 0.41323 21.767 0.930683 22.2713L2.30115 23.6072L1.97762 25.4935C1.8555 26.2053 2.60494 26.7503 3.24457 26.414L4.93857 25.5234L6.63257 26.414C7.26825 26.7482 8.02245 26.2102 7.89951 25.4935L7.57598 23.6072L8.94639 22.2713C9.46357 21.7672 9.17761 20.886 8.46246 20.782ZM5.87914 24.0449C4.89077 23.5253 4.98636 23.5253 3.998 24.0449C4.1801 22.9835 4.23764 23.0561 3.41667 22.2558C4.48275 22.1009 4.43117 22.1782 4.93857 21.1501C5.44448 22.1752 5.39291 22.1007 6.46046 22.2558C5.68937 23.0074 5.68527 22.915 5.87914 24.0449Z"
                          fill="#36D66B"
                        />
                        <path
                          d="M27.919 20.782L26.0251 20.5067L25.1781 18.7906C24.8585 18.1429 23.9319 18.1425 23.6121 18.7906L22.7651 20.5067L20.8712 20.782C20.1564 20.8858 19.8698 21.767 20.3872 22.2714L21.7577 23.6073L21.4342 25.4935C21.3121 26.2053 22.0615 26.7503 22.7012 26.414L24.3952 25.5235L26.0892 26.414C26.7249 26.7483 27.479 26.2102 27.3561 25.4935L27.0326 23.6073L28.403 22.2714C28.9201 21.7672 28.6342 20.886 27.919 20.782ZM25.3357 24.0449C24.3236 23.5129 24.4092 23.5431 23.4546 24.0449C23.6366 22.9836 23.6942 23.0561 22.8733 22.2558C24.0045 22.0914 23.9178 22.1175 24.3952 21.1501C24.901 22.1752 24.8495 22.1007 25.9171 22.2558C25.0984 23.0538 25.1534 22.9817 25.3357 24.0449Z"
                          fill="#36D66B"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_1_6730">
                          <rect
                            width="28"
                            height="28"
                            fill="white"
                            transform="translate(0.666748)"
                          />
                        </clipPath>
                      </defs>
                    </svg>
                    Feedback
                  </span>
                  {selectedOption === "feedback" ? <SelectorIcon /> : <SelectorIcon2 />}
                </div>
                <p>Assistance with account and billing - related inquiries</p>
              </div>
              <div
                className={`cases-card ${selectedOption === "technical_support" ? "selected" : ""}`}
                onClick={() => handleCardClick("technical_support")}
              >
                <div className="card-head">
                  <span>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="29"
                      height="28"
                      viewBox="0 0 29 28"
                      fill="none"
                    >
                      <g clip-path="url(#clip0_1_6746)">
                        <path
                          d="M16.035 11.0265C14.6613 11.0265 13.5436 12.1441 13.5436 13.5178C13.5436 14.8916 14.6613 16.0091 16.035 16.0091C17.4087 16.0091 18.5263 14.8916 18.5263 13.5178C18.5263 12.1441 17.4087 11.0265 16.035 11.0265ZM16.035 14.6995C15.3833 14.6995 14.8532 14.1693 14.8532 13.5177C14.8532 12.8662 15.3833 12.336 16.035 12.336C16.6867 12.336 17.2168 12.8662 17.2168 13.5177C17.2168 14.1694 16.6867 14.6995 16.035 14.6995ZM22.4598 14.8262L21.6137 14.2132C21.6422 13.983 21.6564 13.7506 21.6564 13.5183C21.6564 13.2894 21.6426 13.0606 21.6151 12.8342L22.4614 12.221C22.6777 12.0801 22.9727 11.7481 22.8314 11.0159C22.7637 10.6654 22.6017 10.2562 22.3751 9.86381C21.7472 8.77606 20.9864 8.3001 20.3789 8.60916L19.4264 9.03477C19.0555 8.75329 18.6542 8.52091 18.2269 8.34026L18.1199 7.30919C18.0875 6.62581 17.295 6.20339 16.0351 6.20339C14.7788 6.20339 13.986 6.62464 13.9504 7.30577L13.843 8.34033C13.4156 8.52106 13.0143 8.75351 12.6436 9.03492L11.6932 8.61032C11.463 8.49355 11.0278 8.40414 10.4646 8.89254C10.1949 9.12637 9.92153 9.47137 9.69505 9.86381C9.06718 10.9511 9.03509 11.8479 9.60621 12.2197L10.455 12.8346C10.4274 13.0613 10.4136 13.29 10.4136 13.5184C10.4136 13.7506 10.4278 13.9829 10.4563 14.2131L9.60716 14.8283C9.03517 15.1997 9.06681 16.0969 9.69497 17.1847C9.92153 17.5772 10.1949 17.9221 10.4646 18.156C11.028 18.6445 11.4631 18.555 11.6932 18.4381L12.6532 18.0092C13.0212 18.2872 13.4187 18.5169 13.8418 18.696L13.9503 19.7426C13.9857 20.4239 14.7787 20.8452 16.035 20.8452C17.2949 20.8452 18.0875 20.4228 18.1199 19.7393L18.2281 18.696C18.6512 18.5169 19.0488 18.2872 19.4166 18.0093L20.3788 18.4393C20.9864 18.7486 21.7472 18.2723 22.375 17.1848C23.005 16.0936 23.0356 15.196 22.4598 14.8262ZM20.2631 12.6685C20.3187 12.946 20.3468 13.2319 20.3468 13.5183C20.3468 13.8072 20.318 14.0964 20.2613 14.3776C20.2106 14.629 20.3114 14.8868 20.519 15.0373L21.5464 15.7816C21.5164 15.9349 21.429 16.2039 21.2408 16.5299C21.0525 16.8559 20.8633 17.0661 20.7454 17.1687L19.5828 16.6491C19.3488 16.5445 19.0752 16.5861 18.8829 16.7555C18.4494 17.1373 17.9538 17.4237 17.4098 17.6065C17.1666 17.6883 16.9936 17.9045 16.9671 18.1596L16.8357 19.4261C16.6879 19.4767 16.4113 19.5355 16.0349 19.5355C15.6584 19.5355 15.3817 19.4767 15.234 19.426L15.1027 18.1597C15.0762 17.9045 14.9032 17.6883 14.66 17.6065C14.1161 17.4237 13.6205 17.1373 13.1867 16.7555C12.9945 16.5861 12.7212 16.5445 12.487 16.649L11.3242 17.1685C11.2064 17.0659 11.0171 16.8557 10.829 16.5298C10.6407 16.2037 10.5533 15.9346 10.5234 15.7814L11.5507 15.037C11.7584 14.8865 11.8591 14.6288 11.8084 14.3774C11.7518 14.0961 11.723 13.8071 11.723 13.5183C11.723 13.2328 11.7512 12.9468 11.8067 12.6682C11.8568 12.4172 11.756 12.16 11.5488 12.0098L10.5234 11.2671C10.5533 11.1138 10.6406 10.8447 10.829 10.5185C11.0171 10.1927 11.2064 9.98247 11.3241 9.87989L12.4781 10.3955C12.7128 10.5003 12.9868 10.4582 13.1791 10.288C13.6147 9.90259 14.1133 9.61383 14.661 9.4299C14.9042 9.3482 15.0773 9.13197 15.1037 8.87675L15.2339 7.62254C15.3816 7.57183 15.6583 7.51297 16.0349 7.51297C16.4112 7.51297 16.6878 7.57176 16.8356 7.62247L16.9657 8.87675C16.9922 9.13197 17.1654 9.3482 17.4087 9.4299C17.9562 9.61368 18.4547 9.90237 18.8906 10.288C19.083 10.4581 19.357 10.5002 19.5916 10.3954L20.7454 9.87974C20.8631 9.98233 21.0525 10.1925 21.2407 10.5186C21.4289 10.8445 21.5163 11.1134 21.5463 11.2668L20.5209 12.0098C20.3137 12.1601 20.2129 12.4174 20.2631 12.6685ZM23.7513 3.3467H8.31868C5.82896 3.3467 3.82065 5.36592 3.82065 7.85572V20.6176L1.71077 22.4948V7.6982C1.7107 4.16118 4.62415 1.30958 8.16124 1.30958H20.3846C21.0718 1.30958 21.7282 1.51358 22.2828 1.92406C22.5734 2.13919 22.9835 2.07146 23.1987 1.78081C23.4138 1.49015 23.3526 1.08986 23.0619 0.874725C22.2801 0.29611 21.3543 0 20.3845 0H8.16124C3.90213 0 0.401123 3.4391 0.401123 7.6982V23.9789C0.401123 24.2382 0.572168 24.4732 0.809566 24.5779C1.04689 24.6826 1.34125 24.6374 1.53289 24.4625L3.82065 22.3906V27.3452C3.82065 27.6046 3.96514 27.8396 4.20253 27.9443C4.28744 27.9817 4.37307 28 4.46241 28C4.62269 28 4.77875 27.9411 4.90185 27.8289L8.70668 24.3554C8.82505 24.2474 8.9256 24.153 9.01385 24.0708C9.19595 23.9008 9.36773 23.7403 9.42469 23.718C9.47817 23.6969 9.70392 23.7055 9.94285 23.7087C10.0721 23.7104 10.2221 23.7179 10.3987 23.7179H23.7514C26.2411 23.7179 28.2662 21.6813 28.2662 19.1915V7.85572C28.266 5.36592 26.241 3.3467 23.7513 3.3467ZM26.9564 19.1915C26.9564 20.9592 25.5189 22.4083 23.7512 22.4083H10.3987C10.2288 22.4083 10.0846 22.4008 9.96024 22.3992C8.99508 22.3863 8.84011 22.4441 8.11984 23.116C8.03465 23.1955 7.94553 23.2853 7.83123 23.3896L5.13022 25.8611V20.9072C5.13022 20.9066 5.13022 20.9061 5.13022 20.9055V7.85572C5.13015 6.08801 6.55104 4.65627 8.31868 4.65627H23.7513C25.519 4.65627 26.9565 6.08801 26.9565 7.85572L26.9564 19.1915Z"
                          fill="#36D66B"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_1_6746">
                          <rect
                            width="28"
                            height="28"
                            fill="white"
                            transform="translate(0.333496)"
                          />
                        </clipPath>
                      </defs>
                    </svg>
                    Technical Support
                  </span>
                  {selectedOption === "technical_support" ? <SelectorIcon /> : <SelectorIcon2 />}
                </div>
                <p>Assistance with account and billing - related inquiries</p>
              </div>
            </div>
          </div>
          <div className="casesGroupB">
            <div className="cases-cards-div">
              <div className="subject-input-div">
                <label
                  htmlFor="subject"
                  className="label-tags"
                >
                  Subject
                </label>
                <div className="input-like-div">
                  <input
                    placeholder="Brief summary of the question or issue"
                    name="subject"
                    type="text"
                    value={createCaseData.subject}
                    onChange={handleSubjectChange}
                  />
                </div>
                <p>Maximum 250 characters(250 remaining)</p>
              </div>
              <div className="attach-div">
                <label
                  htmlFor="attachment"
                  className="label-tags"
                >
                  Attachment
                </label>
                <div
                  className={"choose-file-div " + `${selectedFileName === "" && "error"}`}
                  onClick={() => fileInputRef.current.click()}
                >
                  <input
                    type="file"
                    ref={fileInputRef}
                    style={{display: "none"}}
                    onChange={handleAttachmentChange}
                    multiple={false}
                  />
                  <ChooseFileIcon style={{height: "29px", width: "28px"}} /> {(selectedFileName && <p>{selectedFileName.name}</p>) || "Select or drop your file here"}
                </div>
                <p>Attachment should be Less than 500 kB</p>
              </div>
            </div>
            <div className="cases-cards-div">
              {selectedOption === "account_generation" && (
                <>
                  <div className="drop-selectors">
                    <label
                      htmlFor="category"
                      className="label-tags"
                    >
                      Plan Type
                    </label>
                    <Select
                      options={uniqueChallenges.map((item) => ({label: item, value: item}))}
                      value={selectedDropdown2}
                      onChange={handlePlanChange}
                      styles={customStyles}
                      components={{
                        IndicatorSeparator: () => null,
                      }}
                      menuPortalTarget={document.body}
                      isSearchable={false}
                      menuStyle={{width: "100%", zIndex: "100"}}
                    />
                  </div>
                  <div className="drop-selectors">
                    <label
                      htmlFor="category"
                      className="label-tags"
                    >
                      Login Id
                    </label>
                    <Select
                      options={login_id.map((item) => ({label: item.login_id, value: item.login_id}))}
                      value={selectedDropdown3}
                      onChange={handleLoginIdChange}
                      styles={customStyles}
                      components={{
                        IndicatorSeparator: () => null,
                      }}
                      menuPortalTarget={document.body}
                      isSearchable={false}
                      menuStyle={{width: "100%", zIndex: "100"}}
                    />
                  </div>
                </>
              )}{" "}
            </div>
            <div className="cases-cards-div desc-main">
              <label
                htmlFor="description"
                className="label-tags"
              >
                Description
              </label>
              <textarea
                placeholder="Detailed account of the question or issue"
                name="description"
                rows={8}
                value={createCaseData.description}
                onChange={handleDescriptionChange}
              ></textarea>
              <p>Maximum 250 characters(250 remaining)</p>
            </div>
            <div className="cases-cards-div">
              <button
                className="create-btn"
                onClick={handleCreateCase}
                disabled={isSpinner}
              >
                {isSpinner ? <Spinner /> : <>Create Case</>}
              </button>
            </div>
          </div>
          {isModalOpen && (
            <SuccessModal
              setModalOpen={setModalOpen}
              handleNavigation={handleNavigation}
              title="Case Created"
              desc="We will update you on this! Thank you."
              btnText="Close"
            />
          )}
          {isErrorModal && (
            <ErrorModal
              setModalOpen={setErrorModal}
              title="Something Error"
              desc="fill all the details"
              btnText="Close"
            />
          )}
          {isErrorModalApi && (
            <ErrorModal
              setModalOpen={setErrorModalApi}
              title="Something went wrong"
              desc={isErrorModalApiData}
              btnText="Close"
            />
          )}
        </div>
      </div>
    </Card>
  );
};

export default CreateCase;
